import { render, staticRenderFns } from "./modalEditMessage.vue?vue&type=template&id=5c243b43&scoped=true"
import script from "./modalEditMessage.vue?vue&type=script&lang=js"
export * from "./modalEditMessage.vue?vue&type=script&lang=js"
import style0 from "./modalEditMessage.vue?vue&type=style&index=0&id=5c243b43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c243b43",
  null
  
)

export default component.exports